import loadable from '@loadable/component';

export const OrgDashboardManageAdminsPageContainerLoadable = loadable(
  () => import('./OrgDashboardManageAdminsPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardManageAdminsPageContainer,
  },
);
